
import { Component, Prop, Vue } from "vue-property-decorator";
import { CandidateResult } from "@/lib/model/exam/result";

@Component
export default class Mandarin extends Vue {
  @Prop({ type: CandidateResult, default: new CandidateResult() })
  all!: CandidateResult;
  @Prop({ type: Boolean, default: false }) isH5!: boolean;

  get className() {
    const { level, tag } = this.all.chineseAssessmentResult.getEval(this.all);

    if (tag === "未作答") {
      return "noAnswer";
    }

    return `mandarinTitle level-${level}`;
  }
}
